<template>
  <div class="outside_show_box">
    <div class="inside_show_box">
      <div class="header_outside_box">
        <div class="header_inside_one">
          <div class="header_image_box">
            <img src="../assets/doudouImg/douLogo.jpg" class="logo_image"/>
          </div>
          <div class="header_word_box">
            <span class="header_span_title">兼职豆豆</span>
            <span class="header_small_box">官网</span>
            <div class="image_start_box">
              <img src="../assets/index/star1.png" v-for="item in 4" :key="item" style="width: 1.3rem;height: 1.3rem"/>
              <img src="../assets/index/star2.png" style="width: 1.3rem;height: 1.3rem"/>
              <span class="image_start_span">4.9分</span>
            </div>
            <div>
              <p style="color: #999;font-size: 0.85rem;display: flex;align-items: center">251万下载 · 28.6M · 无广告</p>
              <p style="color: #999;font-size: 0.85rem;margin-left: 1rem;margin-top: -1.2rem;margin-left: 12rem;">分类： <span style="border:1px solid #999;padding: 0 0.4rem">生活</span></p>
            </div>
          </div>

        </div>
        <div class="header_btn_box">
          <button class="header_btn_class">安装到手机</button>
          <button class="header_btn_class">立即下载</button>
        </div>
      </div>
      <div class="middle_outside_box">
        <div style="width: 95%;min-height: 85%;margin: 0 auto">
          <img src="../assets/doudouImg/page1.png" class="middle_image_style"/>
          <img src="../assets/doudouImg/page2.png" class="middle_image_style"/>
          <img src="../assets/doudouImg/page3.png" class="middle_image_style"/>
          <img src="../assets/doudouImg/page4.png" class="middle_image_style"/>
        </div>

        <p style="font-size: 1.25rem;font-weight: 600;padding: 0.5rem 0">应用信息</p>
        <p style="font-size: 0.85rem;padding: 0.5rem 0">手机兼职软件就选兼职豆豆！</p>
        <p style="font-size: 0.85rem;padding: 0.5rem 0">兼职豆豆是一款让你找兼职做任务，轻松赚零花钱的APP。玩手机兼职做任务，轻松赚到生活费，兼职豆豆兼职平台，帮你找到新的方式。丰富的任务类型和海量任务，就在兼职豆豆。</p>
      </div>
      <div class="bottom_outside_box">
        <span class="bottom_span_one">版权所有：厦门多豆网络科技有限公司</span>
        <span class="bottom_span_tow">备案号：</span>
        <a href="https://beian.miit.gov.cn" target="_blank" style="font-size: 0.85rem;color: #666">闽ICP备20005393号-1</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "doudou"
}
</script>

<style scoped>
*{
  margin: 0;
  border:0;
  padding: 0;
}
.outside_show_box{
  width: 100%;
  min-height: 66.5rem;
  background-color: rgb(242,246,249);
}
.inside_show_box{
  width: 80%;
  height: 1065px;
  margin: 0 auto;
}
.header_outside_box{
  padding: 1.25rem;
  /*display: flex;*/
  /*justify-content: space-between;*/
  background-color: white;
}
.header_inside_one{
  width: 60%;
  display: flex;
  align-items: center;
}
.header_image_box{
  width: 7.5rem;
  height: 7.5rem;
  border:12px solid rgb(244,244,244);
  border-radius: 0.63rem;
}
.logo_image{
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
  background-position: center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.header_word_box{
  width: 33%;
  height: 85%;
  margin-left: 1.25rem;
}
.header_span_title{
  font-size: 1.5rem;
  font-weight: 600;
}
.header_small_box{
  width: 1.6rem;
  height: 1rem;
  line-height: 1rem;
  font-size: 0.8rem;
  border: 1px solid #267DEB;
  color: #267DEB;
  padding: 0 4px;
  margin-left: 0.8rem;
}
.image_start_box{
  padding: 1rem 0;
}
.image_start_span{
  font-size: 1.3rem;
  margin-left: 1rem;
}
.header_btn_box{
  width: 13%;
  margin-left: 90%;
  margin-top: -9%;
}
.header_btn_class{
  width: 9rem;
  height: 3rem;
  font-size: 1.25rem;
  color: white;
  background-color: #fc5a67;
  margin: 0.5rem 0;
}
.middle_outside_box{
  width: 98.5%;
  min-height: 43rem;
  background-color: white;
  margin: 1rem 0;
  padding: 0.8rem;
}
.middle_image_style{
  width: 24.5%;
  height: 85%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
  background-position: center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.bottom_outside_box{
  width: 100%;
  height: 5%;
  padding: 2rem;
}
.bottom_span_one{
  font-size: 0.85rem;
  margin-left: 30%;
  color: #666;
}
.bottom_span_tow{
  font-size: 0.85rem;
  margin-left: 3%;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/doudou.vue